import React, { useState, useEffect } from 'react';
import { useAuthStore } from '../../store/store';
import { useQueryClient } from '@tanstack/react-query';
import LineGraphsAllTime from './LineGraphsAllTime';
import LineGraphsPastSevenDays from './LineGraphsPastSevenDays';
import BarGraphsToday from './BarGraphsToday';

const UserTrend = ({ checkInPeriodsQuery }) => {
    const uid = useAuthStore(store => store.user?.uid);
    const queryClient = useQueryClient();
    const [selectedPeriod, setSelectedPeriod] = useState('All Time');
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');

    const handleYearSelect = (e) => {
        const year = e.target.value;
        setSelectedYear(year);
        setSelectedMonth(checkInPeriodsQuery.data[year][0]);
        queryClient.invalidateQueries(['checkInPeriods', uid]);
    };

    useEffect(() => {
        if (checkInPeriodsQuery.isSuccess && !selectedYear) {
            const years = Object.keys(checkInPeriodsQuery.data);
            if (years.length > 0) {
                setSelectedYear(years[0]);
                setSelectedMonth(checkInPeriodsQuery.data[years[0]][0]);
            }
        }
    }, [uid, checkInPeriodsQuery.isSuccess]);

    return (
        <>
            <div className='flex flex-col md:flex-row items-center md:justify-between gap-2'>
                <h1 className='text-xl font-semibold'>User Trends</h1>
                <div className='flex items-center gap-3'>
                    <select value={selectedPeriod} className='rounded-md px-1 py-2 w-[100px] text-center text-sm' onChange={(e) => setSelectedPeriod(e.target.value)}>
                        {
                            ['All Time', 'Past Week', 'Today'].map((option, idx) => {
                                return (
                                    <option key={idx} value={option} className={`${option === selectedPeriod ? 'selected' : ''}`}>{option}</option>
                                );
                            })
                        }
                    </select>
                    {selectedPeriod === 'All Time' &&
                        <>
                            <select value={selectedYear} className='rounded-md px-1 py-2 w-[100px] text-center text-sm' onChange={handleYearSelect}>
                                {
                                    Object.keys(checkInPeriodsQuery.data)?.map((year, idx) => {
                                        return (
                                            <option key={idx} value={year} className={`${year === selectedYear ? 'selected' : ''}`} onClick={() => setSelectedYear(year)}>{year}</option>
                                        );
                                    })
                                }
                            </select>

                            <select value={selectedMonth} className='rounded-md px-1 py-2 w-[100px] text-center text-sm' onChange={(e) => setSelectedMonth(e.target.value)}>
                                {
                                    checkInPeriodsQuery.data[selectedYear]?.map((month, idx) => {
                                        return (
                                            <option key={idx} value={month} className={`${month === selectedMonth ? 'selected' : ''}`} onClick={() => setSelectedMonth(month)}>{month}</option>
                                        );
                                    })
                                }
                            </select>
                        </>
                    }
                </div>
            </div>
            <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-4 mt-3 p-4'>
                {selectedPeriod === 'All Time' && <LineGraphsAllTime year={selectedYear} month={selectedMonth} />}
                {selectedPeriod === 'Past Week' && <LineGraphsPastSevenDays />}
                {selectedPeriod === 'Today' && <BarGraphsToday />}
            </div>
        </>
    );
};

export default UserTrend;
